import { XIcon } from "lucide-react";
import * as React from "react";

import classNames from "components/ui/classNames";

import { useAmplitude } from "lib/amplitude/Amplitude";

interface MyProfitAdProps {
  onClose?: () => void;
}

export default function MyProfitAd({ onClose }: MyProfitAdProps) {
  const amplitude = useAmplitude();

  return (
    <div
      className={classNames(
        "relative flex w-full flex-col gap-y-4",
        "rounded-2xl p-8",
        "bg-gradient-to-l from-emerald-400 to-blue-600",
        "ring-2 ring-blue-200 ring-offset-2",
        "dark:border-2 dark:border-[#19ae5a]/20 dark:bg-[#19ae5a]/15 dark:bg-none dark:ring-0 dark:ring-offset-0",
      )}
    >
      <MyProfit width={120} height={41} />

      <div className="flex w-full flex-col items-center gap-4 sm:flex-row">
        <div className="space-y-4">
          <p className="m-0 text-base font-medium tracking-wider text-white">
            Aproveite o desconto de 10% na MyProfit, empresa especializada em imposto de renda para investidores que
            calcula tudo automaticamente para você!
          </p>
        </div>

        <a
          href="https://myprofitweb.com/promo/fundamentei"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            amplitude.logEvent("Click on view MyProfit details link");
          }}
          className={classNames(
            "flex w-full cursor-pointer items-center justify-center rounded-xl bg-sky-800 p-3 text-sm font-bold tracking-wider text-white no-underline",
            "hover:underline",
            "sm:max-w-xs",
            "border border-sky-950 hover:opacity-85",
          )}
        >
          Ver Detalhes
        </a>
      </div>

      {onClose && (
        <div className="absolute right-0 top-0 -mr-2 -mt-2">
          <button
            type="button"
            className="rounded-full bg-red-600 p-1 text-white"
            aria-label="Fechar"
            onClick={() => {
              onClose?.();
              amplitude.logEvent("Closed MyProfit banner");
            }}
          >
            <XIcon className="size-4" strokeWidth={3} />
          </button>
        </div>
      )}
    </div>
  );
}

function MyProfit(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={170} height={59} viewBox="0 0 170 59" {...props}>
      <g fillRule="nonzero" fill="none">
        <path
          fill="#3FAED5"
          d="M59.331 31.951c-.464 9.662-5.938 18.75-16.998 23.954-11.06 5.205-21.829 3.781-31.306-3.79C1.632 44.616-1.528 34.565.667 22.84c.114-.478.274-.944.48-1.39.416-1.023.218-2.82 2.172-2.126 1.585.554.729 1.798.466 2.804-2.756 10.61.052 19.662 8 27.105 8.007 7.498 21.052 8.946 30.736 3.623 10.519-5.777 15.94-17.304 13.636-28.98C54.003 13.003 44.208 4.107 33.076 2.91c-.74-.08-1.48-.098-2.22-.217-.9-.144-1.165-.811-1.141-1.614.031-1.035.8-1.053 1.565-1.074 3.022-.076 5.92.684 8.694 1.696 11.799 4.302 19.392 15.301 19.357 30.25z"
        />
        <path
          fill="#51E491"
          d="M31.276 8.044c-13.134-.215-22.939 8.929-23.26 21.03-.3 11.023 9.01 21.187 19.95 21.783 12.594.685 22.769-8.089 23.579-20.398.072-1.085-.144-2.196-.28-3.287-.14-1.124-.404-2.336 1.172-2.604 1.85-.313 1.511 1.172 1.602 2.175.934 10.3-3.042 18.338-11.936 23.572-8.644 5.088-17.527 4.664-25.939-.754-9.412-6.06-13.226-18.037-9.37-28.525 3.78-10.275 14.43-16.893 25.442-15.797.738.073 1.467.211 2.181.412.651.185 1.545.205 1.249 1.348-.245.947-.58 1.525-1.765 1.28-1.084-.223-2.22-.202-2.625-.235z"
        />
        <path
          fill="#E1E1E1"
          d="M10.156 29.79c.263-11.917 8.498-19.913 20.016-19.998 10.914-.08 19.508 9.383 19.325 20.118-.15 8.904-6.948 16.689-15.724 18.447-1.093.218-2.345.727-2.677-.88-.33-1.606.925-1.551 2.074-1.825 8.815-2.105 14.011-9.325 13.395-18.469-.48-7.134-7.67-13.922-15.74-14.593-11.488-.954-21.546 11.168-16.483 22.987.44 1.031 1.687 2.33-.044 3.143-1.965.915-2.205-.958-2.603-2.134-1.272-3.042-1.785-5.307-1.54-6.796z"
        />
        <path
          fill="#FFF"
          d="M70.4 39.748v-6.643c.337-.425.95-1 1.816-1 .992 0 1.352.596 1.352 1.384v6.259h3.252v-6.643c.317-.425.95-1 1.838-1 .971 0 1.351.596 1.351 1.384v6.259h3.232v-7.451c0-2.108-1.183-3.087-3.063-3.087-1.605 0-2.935.936-3.527 1.83-.422-1.213-1.436-1.83-2.893-1.83-1.606 0-2.915.915-3.359 1.511v-1.256h-3.252v10.283h3.252zm16.38 4.067c1.97-.043 3.534-.531 4.37-2.697l4.67-11.723h-3.492l-2.357 6.498-2.335-6.498h-3.47L88.279 39.8l-.236.552c-.171.425-.642.573-1.392.573-.257 0-.579-.063-.814-.19l-.472 2.909c.343.106 1.114.17 1.414.17zm13.804-4.067v-4.824h3.441c3.187 0 4.93-2.113 4.93-4.674 0-2.582-1.743-4.738-4.93-4.738H96.93v14.236h3.654zm2.913-7.765h-3.052V28.84h3.052c1.01 0 1.757.629 1.757 1.592 0 .943-.746 1.55-1.757 1.55zm10.572 7.765v-4.824h1.86l2.366 4.824h4.163l-2.874-5.23c1.31-.469 2.81-1.792 2.81-4.268 0-2.646-1.774-4.738-4.902-4.738h-7.058v14.236h3.635zm2.867-7.765h-2.987V28.84h2.987c.988 0 1.822.608 1.822 1.571 0 .964-.834 1.572-1.822 1.572zm14.32 7.95c4.287 0 7.481-3.006 7.481-7.303 0-4.297-3.194-7.303-7.481-7.303-4.288 0-7.503 3.006-7.503 7.303 0 4.297 3.215 7.302 7.503 7.302zm.092-3.143c-2.376 0-3.895-1.792-3.895-4.068 0-2.297 1.52-4.067 3.895-4.067 2.355 0 3.874 1.77 3.874 4.067 0 2.276-1.52 4.068-3.874 4.068zm13.068 2.958v-5.656h6.567v-3.116h-6.567v-2.37h6.715v-3.094h-10.36v14.236h3.645zm12.265 0V25.512h-3.7v14.236h3.7zm9.342 0V28.714H170v-3.202h-11.654v3.202h3.999v11.034h3.678z"
        />
      </g>
    </svg>
  );
}
